import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StudentCreTrackingComponent} from './components/student-cre-tracking/student-cre-tracking.component'
import {MatTableModule} from "@angular/material/table";
import {SearchDetailsNotificationService} from "./services/search-details-notification.service";
import {SummaryHeaderComponent} from './components/student-cre-tracking/summary-header/summary-header.component';
import {OverrideModalComponent} from "./components/student-cre-tracking/student-override-modal/student-override-modal.component";
import {SharedModule} from "@tva/ng-migration/shared/shared.module";
import {UIComponentsModule} from "@tva/ng-migration/uicomponents/uicomponents.module";
import {MatDialogModule} from "@angular/material/dialog";
import "./student.config";
import "./student.downgrades";

@NgModule({
    declarations: [
        StudentCreTrackingComponent,
        SummaryHeaderComponent,
        OverrideModalComponent
    ],
    imports: [
        CommonModule,
        UIComponentsModule,
        MatTableModule,
        MatDialogModule,
        SharedModule,
    ],
    providers:[SearchDetailsNotificationService]
})
export class StudentModule { }



